module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.119/css/toolsmenu.css"